module.exports = __webpack_public_path__ + "img/symbol_7.f54cec8c.png";